<template>
  <Layout>
    <div class="container">
      <div class="header">
        <h2>Layout de Extração</h2>
      </div>
      <div class="main">
        <div>
          <ModalLayout />
        </div>

        <div class="tableLayout">
          <Table />
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </Layout>
</template>
<script>
import ModalLayout from "../../components/Modais/ModalLayoutExtracao/index.vue";
import ButtonAdd from "../../components/Button/Button_M1.vue";
import Layout from "../Layout/Layout.vue";
import Table from "./modules/TableExtracao.vue";

export default {
  components: {
    Layout,
    Table,
    ButtonAdd,
    ModalLayout,
  },
  data() {
    return {
      modalView: false,
    };
  },
  methods: {
    click_vmodal() {
      this.modalView = !this.modalView;
    },
  },
};
</script>

<style>
.header h2 {
  font-size: 1.5vw;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.container .tableLayout {
  padding: 1rem;
  background-color: var(--white);
  margin-top: 1rem;
  border-radius: 0.5rem;
}

@media (max-width: 692px) {
  .header h2 {
    font-size: 3.5vw;
  }

  .main {
    width: 100%;
    height: 100%;
    margin-left: 0px;
    padding: 20px;
    transition: 0.5s;
  }
}

@media (max-width: 425px) {
  .header h2 {
    font-size: 1.5rem !important;
    text-align: center;
  }
}
</style>
